<template>
  <div class="w-full overflow-x-auto">
    <BaseMap>
      <MapCard
        v-for="station in stations"
        :key="station.id"
        :details="station.details"
        :y="station.y"
        :x="station.x"
        :img="station.img"
        :station="{ ...station }"
        :setDetails="setDetails"
      />
    </BaseMap>
    <!-- SLIDER -->

    <StationDetailsSlider
      :closeSlider="closeSlider"
      :sliderOpen="sliderOpen"
      :station="{
        ...selectedStation.details,
        img: selectedStation.img,
        id: selectedStation.id,
      }"
    />
  </div>
</template>

<script>
import BaseMap from "./BaseMap.vue";
import MapCard from "./MapCard.vue";

// const details = {
//   id: 1,
//   name: "Ikeja Electric Station",
//   address: "78 Obafemi Awolowo Way, Ikeja, Lagos State",
//   chargers: "1 DC Charger",
//   openTime: "8:00 AM",
//   closeTime: "5:00 PM",
// };
// images
import mapImage from "@/assets/images/map/basemap.png";
import StationDetailsSlider from "./StationDetailsSlider.vue";
export default {
  setup() {
    return {
      mapImage,
    };
  },
  props: ["stations"],
  components: { BaseMap, MapCard, StationDetailsSlider },
  data() {
    return {
      // Define your data properties here
      sliderOpen: false,
      selectedStation: this.stations[0], // Default selected station
    };
  },
  methods: {
    // Define your methods here
    openSlider() {
      this.sliderOpen = true;
    },
    closeSlider() {
      this.sliderOpen = false;
    },
    setDetails(station) {
      this.selectedStation = station;
      this.openSlider();
    },
  },
};
</script>

<style>
</style>